// import {
//   Checkbox,
//   FormControl,
//   FormControlLabel,
//   FormGroup,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
//   Typography,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';

import React, { useMemo } from 'react';

// material ui
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';

// Compute a section default once from spec + incoming sectionState
const buildSectionFromSpec = (spec, sectionState = {}) => {
  const result = {};
  for (const group of Object.keys(spec)) {
    result[group] = {};
    for (const field of spec[group]) {
      const key = field.Key;
      result[group][key] = sectionState[group]?.[key] ?? field.DefaultValue;
    }
  }
  return result;
};

// const PredictiveOccupancyDetectionFormFields = ({
//   data,
//   predictiveOccupancyDetectionSpecification,
//   onSectionSubmit,
// }) => {
//   const initializeFormData = () => {
//     const formData = {};
//     Object.keys(predictiveOccupancyDetectionSpecification).forEach(
//       (section) => {
//         formData[section] = {};
//         predictiveOccupancyDetectionSpecification[section].forEach((field) => {
//           formData[section][field.Key] =
//             data[section]?.[field.Key] ?? field.DefaultValue;
//         });
//       },
//     );
//     return formData;
//   };

//   const [formData, setFormData] = useState(initializeFormData());

//   useEffect(() => {
//     setFormData(initializeFormData());
//   }, [data, predictiveOccupancyDetectionSpecification]);

//   const handleInputChange = (section, key, value) => {
//     const updatedData = {
//       ...formData,
//       [section]: { ...formData[section], [key]: value },
//     };
//     setFormData(updatedData);
//     onSectionSubmit(updatedData);
//   };

//   const handleIndividualScheduleChange = (day, key, value) => {
//     const updatedSchedule = {
//       ...formData.baseline_model.individual_schedule,
//       [day]: {
//         ...formData.baseline_model.individual_schedule[day],
//         [key]: value,
//       },
//     };
//     const updatedData = {
//       ...formData,
//       baseline_model: {
//         ...formData.baseline_model,
//         individual_schedule: updatedSchedule,
//       },
//     };
//     setFormData(updatedData);
//     onSectionSubmit(updatedData);
//   };

//   const isUseIndividualSchedule =
//     formData.baseline_model?.use_individual_schedule;

//   return (
//     <form>
//       {Object.keys(predictiveOccupancyDetectionSpecification).map((section) => (
//         <>
//           <Typography
//             variant="subtitle1"
//             gutterBottom
//             sx={{ color: 'text.secondary' }}
//           >
//             {section.replace('_', ' ')}
//           </Typography>
//           <Grid container spacing={2}>
//             {predictiveOccupancyDetectionSpecification[section].map((field) => {
//               const { Key, DisplayName, Type, Options } = field;
//               const fieldValue = formData[section][Key];

//               if (
//                 Type === 'list[str]' &&
//                 Key === 'occupancy_source_exclusion'
//               ) {
//                 return (
//                   <Grid item xs={12} sm={12} key={Key}>
//                     <FormControl fullWidth>
//                       <InputLabel id="occupancy-source-exclusion-label">
//                         {DisplayName}
//                       </InputLabel>
//                       <Select
//                         multiple
//                         variant="filled"
//                         value={fieldValue || []}
//                         disableUnderline
//                         sx={{ borderRadius: 1 }}
//                         onChange={(e) =>
//                           handleInputChange(section, Key, e.target.value)
//                         }
//                       >
//                         {Options.map((option) => (
//                           <MenuItem key={option} value={option}>
//                             {option}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 );
//               }

//               if (Type === 'list[int]' && Key === 'working_days') {
//                 const dayNameToNumber = {
//                   Monday: 0,
//                   Tuesday: 1,
//                   Wednesday: 2,
//                   Thursday: 3,
//                   Friday: 4,
//                   Saturday: 5,
//                   Sunday: 6,
//                 };
//                 return (
//                   <Grid item xs={12} sm={8} key={Key}>
//                     <FormControl fullWidth>
//                       <InputLabel id="working_days">{DisplayName}</InputLabel>
//                       <Select
//                         multiple
//                         variant="filled"
//                         label={DisplayName}
//                         disableUnderline
//                         disabled={isUseIndividualSchedule}
//                         sx={{ borderRadius: 1 }}
//                         value={fieldValue || []}
//                         onChange={(e) =>
//                           handleInputChange(section, Key, e.target.value)
//                         }
//                       >
//                         {Object.keys(dayNameToNumber).map((day) => (
//                           <MenuItem key={day} value={dayNameToNumber[day]}>
//                             {day}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 );
//               }

//               if (Type === 'int') {
//                 return (
//                   <Grid item xs={12} sm={2} key={Key}>
//                     <TextField
//                       fullWidth
//                       variant="filled"
//                       label={DisplayName}
//                       disabled={isUseIndividualSchedule}
//                       InputProps={{ disableUnderline: true }}
//                       sx={{
//                         '& .MuiFilledInput-root': {
//                           borderRadius: 1, // Adjust borderRadius as needed
//                           overflow: 'hidden', // Prevents any sharp edges from overflowing
//                         },
//                       }}
//                       type="number"
//                       inputProps={{
//                         min: 0, // Minimum value
//                         max: 23, // Maximum value
//                         step: 1, // Increment steps
//                       }}
//                       value={fieldValue ?? 0}
//                       onChange={(e) =>
//                         handleInputChange(
//                           section,
//                           Key,
//                           parseInt(e.target.value),
//                         )
//                       }
//                     />
//                   </Grid>
//                 );
//               }

//               if (Type === 'bool') {
//                 return (
//                   <Grid item xs={12} sm={4} key={Key}>
//                     <FormGroup>
//                       <FormControlLabel
//                         control={
//                           <Checkbox
//                             label={DisplayName}
//                             checked={!!fieldValue}
//                             onChange={(e) =>
//                               handleInputChange(section, Key, e.target.checked)
//                             }
//                           />
//                         }
//                         label={DisplayName}
//                       />
//                     </FormGroup>
//                   </Grid>
//                 );
//               }

//               // Special case for individual_schedule (Type === 'dict' and Key === 'individual_schedule')
//               if (Type === 'dict' && Key === 'individual_schedule') {
//                 return (
//                   <Grid item xs={12} key={Key}>
//                     {/* <Typography variant="subtitle1" gutterBottom>{DisplayName}</Typography> */}
//                     <Grid container spacing={2}>
//                       {Object.keys(fieldValue).map((day) => (
//                         <React.Fragment key={day}>
//                           <Grid item xs={12} sm={2}>
//                             <FormControlLabel
//                               control={
//                                 <Checkbox
//                                   checked={fieldValue[day].workday}
//                                   disabled={!isUseIndividualSchedule}
//                                   onChange={(e) =>
//                                     handleIndividualScheduleChange(
//                                       day,
//                                       'workday',
//                                       e.target.checked,
//                                     )
//                                   }
//                                 />
//                               }
//                               label={`${day}`}
//                             />
//                           </Grid>
//                           <Grid item xs={12} sm={5}>
//                             <TextField
//                               fullWidth
//                               variant="filled"
//                               disabled={!isUseIndividualSchedule}
//                               InputProps={{ disableUnderline: true }}
//                               sx={{
//                                 '& .MuiFilledInput-root': {
//                                   borderRadius: 1, // Adjust borderRadius as needed
//                                   overflow: 'hidden', // Prevents any sharp edges from overflowing
//                                 },
//                               }}
//                               label={`${day} - Start Workday`}
//                               type="number"
//                               inputProps={{
//                                 min: 0, // Minimum value
//                                 max: 23, // Maximum value
//                                 step: 1, // Increment steps
//                               }}
//                               value={fieldValue[day].start_workday}
//                               onChange={(e) =>
//                                 handleIndividualScheduleChange(
//                                   day,
//                                   'start_workday',
//                                   parseInt(e.target.value),
//                                 )
//                               }
//                             />
//                           </Grid>
//                           <Grid item xs={12} sm={5}>
//                             <TextField
//                               fullWidth
//                               variant="filled"
//                               InputProps={{ disableUnderline: true }}
//                               disabled={!isUseIndividualSchedule}
//                               sx={{
//                                 '& .MuiFilledInput-root': {
//                                   borderRadius: 1, // Adjust borderRadius as needed
//                                   overflow: 'hidden', // Prevents any sharp edges from overflowing
//                                 },
//                               }}
//                               label={`${day} - End Workday`}
//                               type="number"
//                               inputProps={{
//                                 min: 0, // Minimum value
//                                 max: 23, // Maximum value
//                                 step: 1, // Increment steps
//                               }}
//                               value={fieldValue[day].end_workday}
//                               onChange={(e) =>
//                                 handleIndividualScheduleChange(
//                                   day,
//                                   'end_workday',
//                                   parseInt(e.target.value),
//                                 )
//                               }
//                             />
//                           </Grid>
//                         </React.Fragment>
//                       ))}
//                     </Grid>
//                   </Grid>
//                 );
//               }

//               return null;
//             })}
//           </Grid>
//         </>
//       ))}
//     </form>
//   );
// };

const PredictiveOccupancyDetectionFormFields = ({
  sectionState, // the whole predictive_occupancy_detection object
  predictiveOccupancyDetectionSpecification,
  onSectionSubmit, // receives the updated section object
}) => {
  const value = useMemo(
    () =>
      buildSectionFromSpec(
        predictiveOccupancyDetectionSpecification,
        sectionState,
      ),
    [predictiveOccupancyDetectionSpecification, sectionState],
  );

  const updateField = (section, key, nextVal) => {
    const next = {
      ...value,
      [section]: { ...value[section], [key]: nextVal },
    };
    onSectionSubmit(next);
  };

  const updateSchedule = (day, key, nextVal) => {
    const sched = value.baseline_model.individual_schedule;
    const next = {
      ...value,
      baseline_model: {
        ...value.baseline_model,
        individual_schedule: {
          ...sched,
          [day]: { ...sched[day], [key]: nextVal },
        },
      },
    };
    onSectionSubmit(next);
  };

  const isUseIndividualSchedule =
    !!value.baseline_model?.use_individual_schedule;

  return (
    <form>
      {Object.keys(predictiveOccupancyDetectionSpecification).map((section) => (
        <React.Fragment key={section}>
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: 'text.secondary' }}
          >
            {section.replace('_', ' ')}
          </Typography>
          <Grid container spacing={2}>
            {predictiveOccupancyDetectionSpecification[section].map((field) => {
              const { Key, DisplayName, Type, Options } = field;
              const fieldValue = value[section][Key];

              if (
                Type === 'list[str]' &&
                Key === 'occupancy_source_exclusion'
              ) {
                return (
                  <Grid key={Key} size={12}>
                    <FormControl fullWidth>
                      <InputLabel id="occupancy-source-exclusion-label">
                        {DisplayName}
                      </InputLabel>
                      <Select
                        multiple
                        variant="filled"
                        value={fieldValue || []}
                        disableUnderline
                        sx={{ borderRadius: 1 }}
                        onChange={(e) =>
                          updateField(section, Key, e.target.value)
                        }
                      >
                        {Options.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                );
              }

              if (Type === 'list[int]' && Key === 'working_days') {
                const dayNameToNumber = {
                  Monday: 0,
                  Tuesday: 1,
                  Wednesday: 2,
                  Thursday: 3,
                  Friday: 4,
                  Saturday: 5,
                  Sunday: 6,
                };
                return (
                  <Grid
                    key={Key}
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <FormControl fullWidth>
                      <InputLabel id="working_days">{DisplayName}</InputLabel>
                      <Select
                        multiple
                        variant="filled"
                        label={DisplayName}
                        disableUnderline
                        disabled={isUseIndividualSchedule}
                        sx={{ borderRadius: 1 }}
                        value={fieldValue || []}
                        onChange={(e) =>
                          updateField(section, Key, e.target.value)
                        }
                      >
                        {Object.keys(dayNameToNumber).map((day) => (
                          <MenuItem key={day} value={dayNameToNumber[day]}>
                            {day}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                );
              }

              if (Type === 'int') {
                return (
                  <Grid
                    key={Key}
                    size={{
                      xs: 12,
                      sm: 2
                    }}>
                    <TextField
                      fullWidth
                      variant="filled"
                      label={DisplayName}
                      disabled={isUseIndividualSchedule}
                      sx={{
                        '& .MuiFilledInput-root': {
                          borderRadius: 1,
                          overflow: 'hidden',
                        },
                      }}
                      type="number"
                      value={fieldValue ?? 0}
                      onChange={(e) =>
                        updateField(section, Key, parseInt(e.target.value, 10))
                      }
                      slotProps={{
                        input: { disableUnderline: true },
                        htmlInput: { min: 0, max: 23, step: 1 }
                      }} />
                  </Grid>
                );
              }

              if (Type === 'bool') {
                return (
                  <Grid
                    key={Key}
                    size={{
                      xs: 12,
                      sm: 4
                    }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!fieldValue}
                            onChange={(e) =>
                              updateField(section, Key, e.target.checked)
                            }
                          />
                        }
                        label={DisplayName}
                      />
                    </FormGroup>
                  </Grid>
                );
              }

              if (Type === 'dict' && Key === 'individual_schedule') {
                return (
                  <Grid key={Key} size={12}>
                    <Grid container spacing={2}>
                      {Object.keys(fieldValue).map((day) => (
                        <React.Fragment key={day}>
                          <Grid
                            size={{
                              xs: 12,
                              sm: 2
                            }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={fieldValue[day].workday}
                                  disabled={!isUseIndividualSchedule}
                                  onChange={(e) =>
                                    updateSchedule(
                                      day,
                                      'workday',
                                      e.target.checked,
                                    )
                                  }
                                />
                              }
                              label={`${day}`}
                            />
                          </Grid>
                          <Grid
                            size={{
                              xs: 12,
                              sm: 5
                            }}>
                            <TextField
                              fullWidth
                              variant="filled"
                              disabled={!isUseIndividualSchedule}
                              sx={{
                                '& .MuiFilledInput-root': {
                                  borderRadius: 1,
                                  overflow: 'hidden',
                                },
                              }}
                              label={`${day} - Start Workday`}
                              type="number"
                              value={fieldValue[day].start_workday}
                              onChange={(e) =>
                                updateSchedule(
                                  day,
                                  'start_workday',
                                  parseInt(e.target.value, 10),
                                )
                              }
                              slotProps={{
                                input: { disableUnderline: true },
                                htmlInput: { min: 0, max: 23, step: 1 }
                              }} />
                          </Grid>
                          <Grid
                            size={{
                              xs: 12,
                              sm: 5
                            }}>
                            <TextField
                              fullWidth
                              variant="filled"
                              disabled={!isUseIndividualSchedule}
                              sx={{
                                '& .MuiFilledInput-root': {
                                  borderRadius: 1,
                                  overflow: 'hidden',
                                },
                              }}
                              label={`${day} - End Workday`}
                              type="number"
                              value={fieldValue[day].end_workday}
                              onChange={(e) =>
                                updateSchedule(
                                  day,
                                  'end_workday',
                                  parseInt(e.target.value, 10),
                                )
                              }
                              slotProps={{
                                input: { disableUnderline: true },
                                htmlInput: { min: 0, max: 23, step: 1 }
                              }} />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                  </Grid>
                );
              }

              return null;
            })}
          </Grid>
        </React.Fragment>
      ))}
    </form>
  );
};

export default PredictiveOccupancyDetectionFormFields;
